import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { RUN_LATEST_EXECUTION_KEY } from '@/utils/queryKeys.ts';
import { Execution } from '@/types/runs.ts';
import useRunId from '@/hooks/useRunId.ts';

const useInvalidateAutomation = (automationId: string) => {
  const queryClient = useQueryClient();
  const runId = useRunId();
  return useCallback(
    (execution: Execution, executionRunId: string): unknown[][] => {
      // we don't need to save for all runs/automations, only for the current one
      if (executionRunId === runId) {
        queryClient.setQueryData<Execution>(
          RUN_LATEST_EXECUTION_KEY(automationId, executionRunId),
          execution,
        );
      }
      return [RUN_LATEST_EXECUTION_KEY(automationId, executionRunId)];
    },
    [automationId, queryClient, runId],
  );
};

export default useInvalidateAutomation;
